import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/tax-ranges',
    name: 'tax-range',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/tax-range/index.vue')
  }
]
